import styled, { css } from 'styled-components';

import { theme } from './theme';

import isDarkColour from '../utils/isDarkColour';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const CarouselStyles = styled.div`
  .slick-track {
    align-items: center;
    display: flex;
  }

  .slick-dots li {
    width: 9px;
    height: 9px;
    margin: 0 10px;

    button {
      width: 9px;
      height: 9px;

      &:before {
        content: '';
        width: 9px;
        height: 9px;
        opacity: 1;

        border: 1px solid ${theme.colors.black};
        border-radius: 50%;

        ${(props) =>
          isDarkColour(props.colourScheme) &&
          css`
            border-color: white;
          `}
      }
    }
  }

  .slick-dots li.slick-active button::before {
    background-color: ${theme.colors.black};

    ${(props) =>
      isDarkColour(props.colourScheme) &&
      css`
        background-color: white;
      `}
  }

  .slick-vertical {
    .slick-slide {
      background-color: transparent;
      opacity: 0;
      transition: 0.4s;
    }

    .slick-active {
      opacity: 1;
    }
  }
`;

export default CarouselStyles;
